import styled from 'styled-components';
import SuccessPageAttribution from 'views/PostEnrollment/SuccessPageAttribution';
import SuccessPageButton from 'views/PostEnrollment/SuccessPageButtons';
import cbRewardsCardPending from 'views/SuccessCBRewards/cbRewardsCardPending.svg';
import { Content, Title } from 'views/SuccessCBRewards/Layout';

import {
  Card,
  DescriptionText,
  PageWrapper,
  PostEnrollmentChimeLogo as ChimeLogo,
} from 'styles/styleMixins';

import { media } from 'theme/media';

const SuccessPage = () => {
  return (
    <SuccessPageAttribution>
      <PageWrapper>
        <Card showFooterDisclosure>
          <Content>
            <ChimeLogo alwaysShow />
            <CBRewardsCardPending />
            <BigTitle>That new card is almost yours!</BigTitle>
            <SuccessDescriptionText>
              We’ll email you when we find the right credit card for you. While
              you wait, download the app to finish your account setup.
            </SuccessDescriptionText>
            <SuccessPageButton
              justifyContent="center"
              variation="l"
              eventContext="success_cb_rewards_pending"
            >
              Get the app
            </SuccessPageButton>
          </Content>
        </Card>
      </PageWrapper>
    </SuccessPageAttribution>
  );
};

export default SuccessPage;

const CBRewardsCardPending = styled.img.attrs({
  src: cbRewardsCardPending,
  alt: 'Credit Builder Rewards Card Pending',
})`
  width: 85%;
  ${media.mobileOnly`
    order: 1;
    padding-top: 2rem;
  `}
`;

const BigTitle = styled(Title)`
  font-size: 1.75rem;
  ${media.mobileOnly`
    padding-top: 1rem;
    text-align: center;
  `}
`;

const SuccessDescriptionText = styled(DescriptionText)`
  margin: 0;
`;
